import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';

export default InjectedStyledComponent('section', 'questionWizard', ['forwardButtonWrapper']);
